import React, { Component } from 'react'
import MaterialUiButton from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faBookmark } from '@fortawesome/free-solid-svg-icons'
import { Loader } from '../../common'
import DatePicker from '../../common/DatePicker'

import * as dataActions from '../../actions/Data'
import * as Functions from '../../../helpers/Functions'
import * as configActions from '../../actions/Config'
import * as laundryBookingsActions from '../../actions/LaundryBookings'
import * as Strings from './strings'

class BookOrUnbookLaundryTimeModal extends Component {
  state = {
    date: Functions.parseDate(new Date()),
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, laundryBookings } = this.props

    if (
      nextProps.config.bookOrUnbookLaundryTimeModal.show &&
      !config.bookOrUnbookLaundryTimeModal.show
    ) {
      this.setState({ errorMessage: '' })
      this.fetch(nextProps.data.communities[nextProps.data.community.id])
    }

    if (
      nextProps.laundryBookings.isCreating.length !==
        laundryBookings.isCreating.length &&
      nextProps.laundryBookings.errorCreating === null
    ) {
      this.props.showSnackbar(Strings.default.LAUNDRY_TIME_BOOKED)
    } else if (
      nextProps.laundryBookings.isDeleting.length !==
        laundryBookings.isDeleting.length &&
      !nextProps.laundryBookings.errorDeleting
    ) {
      this.props.showSnackbar(Strings.default.LAUNDRY_TIME_UNBOOKED)
    } else if (
      (!nextProps.laundryBookings.isCreating &&
        nextProps.laundryBookings.errorCreating !== null &&
        laundryBookings.isCreating) ||
      (!nextProps.laundryBookings.isDeleting &&
        nextProps.laundryBookings.errorDeleting &&
        laundryBookings.isDeleting)
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  fetch(community) {
    const { user } = this.props

    if (!community.laundrySystem.fetched) {
      this.props.tryGetLaundrySystem(user.token, community.id)
    }
  }

  getTime(timeId) {
    const { data } = this.props
    const times = data.laundrySystem.times

    for (let i = 0; i < times.length; i++) {
      if (times[i].id.toString() === timeId.toString()) {
        return times[i].startTime + '-' + times[i].endTime
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  getName(laundryId) {
    const { data } = this.props
    const laundries = data.laundrySystem.laundries
    const laundryType = data.laundrySystem.laundryRule.laundryType

    for (let i = 0; i < laundries.length; i++) {
      if (laundries[i].id.toString() === laundryId.toString()) {
        return Strings.default.LAUNDRY[laundryType] + ' ' + laundries[i].name
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  timeIsBooked(timeId, laundryId) {
    const { date } = this.state
    const { data } = this.props

    return (
      0 !==
      data.laundrySystem.bookings.filter(
        booking =>
          date === booking.date &&
          timeId.toString() === booking.timeId.toString() &&
          laundryId.toString() === booking.laundryId.toString() &&
          booking.status === 'open'
      ).length
    )
  }

  renderContent() {
    const { errorMessage, date } = this.state
    const { data, laundryBookings, user } = this.props
    const community = data.community

    if (!community.laundrySystem.fetched) {
      return <Loader />
    }

    const laundryType = community.laundrySystem.laundryRule.laundryType
    const times = community.laundrySystem.times
    const laundries = community.laundrySystem.laundries
    const bookings = community.laundrySystem.bookings
    const apartment = laundryBookings.selected
    const myBookings = bookings.filter(
      booking =>
        booking.apartmentId.toString() === apartment.id.toString() &&
        booking.status === 'open'
    )

    return (
      <DialogContent>
        <DialogContentText>
          {Strings.default.LAUNDRY_TIME_INFO}
        </DialogContentText>
        {errorMessage === '' ? null : (
          <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
        )}
        <DatePicker
          value={date}
          placeholder={Strings.default.SELECT_DATE_FOR_BOOKING}
          onChange={text => this.setState({ date: text })}
          minDate={date}
        />
        <DialogContentText style={{ marginTop: 25 }}>
          {Strings.default.FREE_LAUNDRY_TIME + date + ')'}
        </DialogContentText>
        {times
          .sort((o1, o2) => (o1.startTime > o2.startTime ? 1 : -1))
          .map(time => {
            return laundries.map(laundry => {
              if (this.timeIsBooked(time.id, laundry.id)) {
                return null
              }

              return (
                <BookingRow
                  key={time.id * laundry.id}
                  date={date}
                  time={time.startTime + '-' + time.endTime}
                  laundry={
                    Strings.default.LAUNDRY[laundryType] + ' ' + laundry.name
                  }
                  icon={faBookmark}
                  color={'#289e64'}
                  label={'Boka'}
                  onClick={() => {
                    const postData = {
                      laundryId: laundry.id,
                      timeId: time.id,
                      date
                    }

                    this.props.tryCreateBooking(
                      user.token,
                      apartment.id,
                      data.community.id,
                      postData
                    )
                  }}
                />
              )
            })
          })}
        <DialogContentText style={{ marginTop: 25 }}>
          {Strings.default.CURRENT_BOOKINGS + apartment.number}
        </DialogContentText>
        {myBookings.length === 0 ? (
          <p style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
            {Strings.default.APARTMENT +
              ' ' +
              apartment.number +
              ' ' +
              Strings.default.NO_BOOKINGS}
          </p>
        ) : null}
        {myBookings.map(booking => {
          return (
            <BookingRow
              key={booking.id}
              date={booking.date}
              time={this.getTime(booking.timeId)}
              laundry={this.getName(booking.laundryId)}
              onClick={() =>
                this.props.tryDeleteBooking(
                  user.token,
                  apartment.id,
                  data.community.id,
                  booking.id
                )
              }
              loading={laundryBookings.isDeleting.indexOf(booking.id) !== -1}
            />
          )
        })}
      </DialogContent>
    )
  }

  render() {
    const { config, classes, laundryBookings } = this.props

    if (!laundryBookings.selected) return null

    const apartment = laundryBookings.selected.appartment

    return (
      <Dialog
        open={config.bookOrUnbookLaundryTimeModal.show}
        aria-labelledby={'form-dialog-title'}
      >
        <DialogTitle id={'form-dialog-title'}>
          {Strings.default.LAUNDRY_TIME_FOR_APARTMENT + ' ' + apartment}
        </DialogTitle>
        {this.renderContent()}
        <DialogActions>
          <MaterialUiButton
            onClick={() => this.props.hideBookOrbookOrUnbookLaundryTimeModal()}
            classes={{ label: classes.warningButtonText }}
          >
            {Strings.default.CLOSE}
          </MaterialUiButton>
        </DialogActions>
      </Dialog>
    )
  }
}

const BookingRow = props => {
  const {
    date,
    time,
    laundry,
    icon = faTrash,
    color = '#e57373',
    label = 'Avboka',
    onClick,
    loading
  } = props

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <p
            style={{
              fontSize: 10,
              margin: 0,
              color: 'rgba(0, 0, 0, 0.87)',
              fontWeight: 'bold'
            }}
          >
            {date}
          </p>
          <p
            style={{
              fontSize: 10,
              margin: 0,
              color: 'rgba(0, 0, 0, 0.87)',
              fontWeight: 'bold'
            }}
          >
            {time}
          </p>
        </div>
        <p
          style={{
            fontSize: 18,
            marginLeft: 15,
            color: 'rgba(0, 0, 0, 0.87)'
          }}
        >
          {laundry}
        </p>
      </div>
      {loading ? (
        <CircularProgress style={{ color }} thickness={6} size={20} />
      ) : (
        <IconButton aria-label={'Avboka'} onClick={() => onClick()}>
          <p
            style={{ fontSize: 12, fontWeight: 'bold', color, marginRight: 15 }}
          >
            {label}
          </p>
          <FontAwesomeIcon icon={icon} color={color} style={{ fontSize: 18 }} />
        </IconButton>
      )}
    </div>
  )
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

function mapStateToProps({ data, user, config, laundryBookings }) {
  return { data, user, config, laundryBookings }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryBookingsActions, ...dataActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BookOrUnbookLaundryTimeModal)



// WEBPACK FOOTER //
// ./src/components/containers/BookOrUnbookLaundryTimeModal/index.js